var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 35.432,
    viewBox: "0 0 29 35.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48bfe3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secure-payment",
    transform: "translate(-32.499 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8436",
    "data-name": "Path 8436",
    d: "M138.037,131.662a1.245,1.245,0,0,0-.875-.36,1.228,1.228,0,0,0-.874.36l-4.331,4.331-1.5-1.5a1.237,1.237,0,0,0-1.748,1.75l2.37,2.37a1.228,1.228,0,0,0,.874.358h0a1.229,1.229,0,0,0,.875-.359l5.205-5.205A1.239,1.239,0,0,0,138.037,131.662Z",
    transform: "translate(-86.367 -118.309)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    d: "M61.44,7.3a.643.643,0,0,0-.359-.523L47.28.064a.643.643,0,0,0-.563,0l-13.8,6.715a.643.643,0,0,0-.359.523,35.536,35.536,0,0,0,1.111,10.92,29.268,29.268,0,0,0,4.11,9.255A24.212,24.212,0,0,0,46.7,35.359a.643.643,0,0,0,.592,0,24.212,24.212,0,0,0,8.924-7.883,29.266,29.266,0,0,0,4.11-9.255A35.537,35.537,0,0,0,61.44,7.3ZM47,24.907a8.181,8.181,0,1,1,8.181-8.181A8.191,8.191,0,0,1,47,24.907Z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePayment);
export default __webpack_public_path__ + "static/media/secure-payment.89961c0b42126e4bf25480b4501b9fb9.svg";
export { ForwardRef as ReactComponent };